import React from "react";

const CircleIcon64pxSvg = (props) => {
  return (
    <svg
      {...props}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.6111 63.0474C14.2087 63.0755 0.0785488 48.991 0.050398 31.5887C0.0222472 14.1864 14.1068 0.0561731 31.5091 0.0280223C48.9114 -0.000128503 63.0416 14.0844 63.0698 31.4867C63.0979 48.8891 49.0134 63.0192 31.6111 63.0474ZM31.5209 7.32223C18.1471 7.34387 7.32297 18.203 7.34461 31.5769C7.36624 44.9507 18.2254 55.7748 31.5993 55.7532C44.9731 55.7316 55.7972 44.8724 55.7756 31.4985C55.7539 18.1247 44.8948 7.3006 31.5209 7.32223Z"
        fill="#19293C"
      />
    </svg>
  );
};

export default CircleIcon64pxSvg;
